// branch-group.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpMesageHandlerService } from '@core/service/http-mesage-handler';
import { AuthManagementService } from '@core/service/auth-management.service';
import { DefaultResponse } from '@core/models/Http/DefaultResponse';
import { environment } from '@enviroment/environment';

@Injectable({ providedIn: 'root' })
export class BranchGroupService {
  private branchGroupIdSubject = new BehaviorSubject<string | null>(
    localStorage.getItem('branchGroupId')
  );
  branchGroupId$ = this.branchGroupIdSubject.asObservable();

  constructor(
    private http: HttpClient,
    private httpMsgHandler: HttpMesageHandlerService,
    private auth: AuthManagementService
  ) {}

  setBranchGroupId(id: string): void {
    if (id === null || id === undefined) return;

    const current = localStorage.getItem('branchGroupId');

    if (id === '') {
      localStorage.removeItem('branchGroupId');
      this.branchGroupIdSubject.next('');
      return;
    }

    if (current === id) {
      this.branchGroupIdSubject.next(id);
      return;
    }

    const token = this.auth.getUserKey();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'X-Skip-Renew': '1'
    });

    this.http.post<DefaultResponse<string>>(
      `${environment.backend_url}Auth/change-sucursal`,
      JSON.stringify(id),
      { headers }
    ).subscribe({
      next: (res) => {
        this.auth.saveUserKey(res.data);
        localStorage.setItem('branchGroupId', id);
        this.branchGroupIdSubject.next(id);
      },
      error: (err) => {
        if (current) localStorage.setItem('branchGroupId', current);
        else localStorage.removeItem('branchGroupId');
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }
}
